import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../../data/siteData';

const CTASection = ({ onContactClick }) => {
  return (
    <section className="py-20" style={{ backgroundColor: COLORS.background }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-8" style={{ color: COLORS.dark }}>
          Planuojate modernizuoti biblioteką?
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/sprendimai-bibliotekoms"
            className="px-8 py-4 text-base font-medium text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            style={{ backgroundColor: COLORS.green }}
            data-testid="cta-solutions-btn"
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = COLORS.red}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = COLORS.green}
          >
            Peržiūrėti visus sprendimus bibliotekoms
          </Link>
          <button
            onClick={onContactClick}
            className="px-8 py-4 text-base font-medium rounded-lg transition-all duration-300 border-2"
            style={{ 
              color: COLORS.dark,
              borderColor: COLORS.dark,
              backgroundColor: 'transparent'
            }}
            data-testid="cta-contact-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = COLORS.red;
              e.currentTarget.style.borderColor = COLORS.red;
              e.currentTarget.style.color = '#FFFFFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = COLORS.dark;
              e.currentTarget.style.color = COLORS.dark;
            }}
          >
            Susisiekite aptarti tinkamiausią sprendimą
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
